import {BitmapText, IBitmapTextStyle} from "pixi.js";
import {BlockItemDrawProps} from "../FrameBlockItem";
import {inches, lineBlueHeavy} from "../../../const";

const TEXT_STYLE: Partial<IBitmapTextStyle> = {
    fontName: "Arial",
    fontSize: 60,
};

// how far below the cell's top edge the label sits.
const LABEL_INSET = 9 * inches;

// the "slot - opening" overlay on a door cell of a multi-opening frame. Editor only: hidden on the
// exports (external-dimensions mode), and when text is null (a frame with no door slots).
export class SlotLabel {
    private label: BitmapText | null = null;

    draw(props: BlockItemDrawProps, text: string | null) {
        if(!this.label) {
            const label = new BitmapText("", TEXT_STYLE);
            label.tint = lineBlueHeavy;
            label.eventMode = "none";
            label.anchor.set(0.5, 0);
            this.label = label;
        }

        // the dimension container survives the per-draw graphics clear; re-parent in case a grid
        // rebuild handed the item a fresh one.
        const label = this.label;
        if(label.parent !== props.dimensionContainer) props.dimensionContainer.addChild(label);

        label.visible = !!text && !props.elev.viewSettings.externalDimensions.value;
        label.text = text ?? "";
        label.position.set((props.startX + props.endX) / 2, Math.min(props.startY, props.endY) + LABEL_INSET);
    }

    destroy() {
        if(this.label && !this.label.destroyed) this.label.destroy();
        this.label = null;
    }
}
